import { createRef, useEffect, memo } from 'react';
import lottieWeb, { AnimationConfigWithData } from 'lottie-web';

type Props = Pick<AnimationConfigWithData, 'animationData'>;

function LottieAnimation({ animationData }: Props) {
  const myRef = createRef<HTMLDivElement>();

  useEffect(() => {
    if (myRef.current) {
      lottieWeb.loadAnimation({
        container: myRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    }
  }, [animationData, myRef]);

  return <div ref={myRef} />;
}

export default memo(LottieAnimation);
